import { PayrollActionTypes } from './payroll.types'

//New Tax rule
export const newTaxRuleRequest = data => ({
    type: PayrollActionTypes.NEW_TAX_RULE_REQUEST,
    payload: data
})

export const newTaxRuleRequestSuccess = data => ({
    type: PayrollActionTypes.NEW_TAX_RULE_REQUEST_SUCCESS,
    payload: data
})

export const newTaxRuleRequestError = data => ({
    type: PayrollActionTypes.NEW_TAX_RULE_REQUEST_ERROR,
    payload: data
})

export const newTaxRuleRequestStatus = data => ({
    type: PayrollActionTypes.NEW_TAX_RULE_REQUEST_STATUS,
    payload: data
})

//Tax rule list
export const taxRuleListRequest = data => ({
    type: PayrollActionTypes.TAX_RULE_LIST_REQUEST,
    payload: data
})

export const taxRuleListRequestSuccess = data => ({
    type: PayrollActionTypes.TAX_RULE_LIST_REQUEST_SUCCESS,
    payload: data
})

export const taxRuleListRequestError = data => ({
    type: PayrollActionTypes.TAX_RULE_LIST_REQUEST_ERROR,
    payload: data
})

//Update Tax rule
export const updateTaxRuleRequest = data => ({
    type: PayrollActionTypes.UPDATE_TAX_RULE_REQUEST,
    payload: data
})

export const updateTaxRuleRequestSuccess = data => ({
    type: PayrollActionTypes.UPDATE_TAX_RULE_REQUEST_SUCCESS,
    payload: data
})

export const updateTaxRuleRequestError = data => ({
    type: PayrollActionTypes.UPDATE_TAX_RULE_REQUEST_ERROR,
    payload: data
})

export const updateTaxRuleRequestStatus = data => ({
    type: PayrollActionTypes.UPDATE_TAX_RULE_REQUEST_STATUS,
    payload: data
})

//Provisional payslip
export const provisionalPayslipRequest = data => ({
    type: PayrollActionTypes.PROVISIONAL_PAYSLIP_REQUEST,
    payload: data
})

export const provisionalPayslipRequestSuccess = data => ({
    type: PayrollActionTypes.PROVISIONAL_PAYSLIP_REQUEST_SUCCESS,
    payload: data
})

export const provisionalPayslipRequestError = data => ({
    type: PayrollActionTypes.PROVISIONAL_PAYSLIP_REQUEST_ERROR,
    payload: data
})

export const provisionalPayslipRequestStatus = data => ({
    type: PayrollActionTypes.PROVISIONAL_PAYSLIP_REQUEST_STATUS,
    payload: data
})

//New payslip
export const newPayslipRequest = data => ({
    type: PayrollActionTypes.NEW_PAYSLIP_LIST_REQUEST,
    payload: data
})

export const newPayslipRequestSuccess = data => ({
    type: PayrollActionTypes.NEW_PAYSLIP_LIST_REQUEST_SUCCESS,
    payload: data
})

export const newPayslipRequestError = data => ({
    type: PayrollActionTypes.NEW_PAYSLIP_LIST_REQUEST_ERROR,
    payload: data
})

export const newPayslipRequestStatus = data => ({
    type: PayrollActionTypes.NEW_PAYSLIP_LIST_REQUEST_STATUS,
    payload: data
})

//payslip list
export const payslipListRequest = data => ({
    type: PayrollActionTypes.PAYSLIP_LIST_REQUEST,
    payload: data
})

export const payslipListRequestSuccess = data => ({
    type: PayrollActionTypes.PAYSLIP_LIST_REQUEST_SUCCESS,
    payload: data
})

export const payslipListRequestError = data => ({
    type: PayrollActionTypes.PAYSLIP_LIST_REQUEST_ERROR,
    payload: data
})

//payslip detail
export const payslipDetailRequest = data => ({
    type: PayrollActionTypes.PAYSLIP_DETAIL_REQUEST,
    payload: data
})

export const payslipDetailRequestSuccess = data => ({
    type: PayrollActionTypes.PAYSLIP_DETAIL_REQUEST_SUCCESS,
    payload: data
})
export const payslipDetailRequestError = data => ({
    type: PayrollActionTypes.PAYSLIP_DETAIL_REQUEST_ERROR,
    payload: data
})

//update payslip payment
export const updatePayslipPaymentRequest = data => ({
    type: PayrollActionTypes.UPDATE_PAYSLIP_PAYMENT_STATUS_REQUEST,
    payload: data
})

export const updatePayslipPaymentRequestSuccess = data => ({
    type: PayrollActionTypes.UPDATE_PAYSLIP_PAYMENT_STATUS_REQUEST_SUCCESS,
    payload: data
})

export const updatePayslipPaymentRequestError = data => ({
    type: PayrollActionTypes.UPDATE_PAYSLIP_PAYMENT_STATUS_REQUEST_ERROR,
    payload: data
})

export const updatePayslipPaymentRequestStatus = data => ({
    type: PayrollActionTypes.UPDATE_PAYSLIP_PAYMENT_STATUS_REQUEST_STATUS,
    payload: data
})